import { useLocation } from "react-router-dom";
import { Layout } from "antd";
import ModuleBar from "./ModuleBar";
import Footer from "./Footer";
import { LoadingProvider } from "../../store/context/loading-context"
import { AxiosInterceptor } from "./AxiosInterceptor";
import ModalFirstPassword from "../modal/user/ModalFirstPassword";

const { Content } = Layout;

function Main({ children }) {



  let { pathname } = useLocation();
  pathname = pathname.replace("/", "");


  return (
    <Layout
      className={`layout-dashboard ${
        pathname === "profile" ? "layout-profile" : ""
      } ${pathname === "rtl" ? "layout-dashboard-rtl" : ""}`}
    >
      <Layout>
        <LoadingProvider>
          <ModuleBar />

          <AxiosInterceptor>
            <Content className="content-ant" style={{"overflow":"hidden", "position":"relative"}}>
              {children}
            </Content>              
          </AxiosInterceptor>

          {/* ผู้ใช้ใหม่ที่เพิ่งเข้าระบบครั้งแรก ต้องตั้งรหัสผ่านก่อนใช้งาน */}
          <ModalFirstPassword />

        <Footer />
        </LoadingProvider>
      </Layout>
    </Layout>
  );
}

export default Main;
